import CommercialInsuranceSections from 'domains/signupDirect/Evaluation/Insurance/Commercial/CommercialInsuranceSections';
import { DirectSignupInsuranceEligibilitySection } from 'domains/signupDirect/Evaluation/Insurance/Medicaid/InsuranceCardSection';
import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from 'domains/signupDirect/misc/mixpanelTracking';
import { EvaluationFormType } from 'domains/signupDirect/schemas/evaluationSchema';
import { EligibilityCheckResult } from 'domains/signupv4/Insurance/types';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTrack } from 'utils/hooks/useMixPanel';

type Props = {
  showUpdateInfo: boolean;
  setShowUpdateInfo: (show: boolean) => void;
};

const InsuranceSections: React.FC<Props> = ({ showUpdateInfo, setShowUpdateInfo }) => {
  const { isResumedLead } = useSignupDirectCtx();
  const { track } = useTrack();
  const billingInfo = useWatch<EvaluationFormType, 'billingInfo'>({ name: 'billingInfo' });
  const isMedicareOrMedicaid = billingInfo.type === 'insurance-medicaid' || billingInfo.type === 'insurance-medicare';

  if (isMedicareOrMedicaid) {
    if (billingInfo.type === 'insurance-medicaid') {
      track(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.MEDICAID, { isResumedLead });
      return (
        <>
          <DirectSignupInsuranceEligibilitySection
            showUpdateInfo={showUpdateInfo}
            setShowUpdateInfo={setShowUpdateInfo}
          />
        </>
      );
    } else if (billingInfo.type === 'insurance-medicare') {
      track(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.MEDICARE, { isResumedLead });
      
      return (
        <>
          <DirectSignupInsuranceEligibilitySection
            showUpdateInfo={showUpdateInfo}
            setShowUpdateInfo={setShowUpdateInfo}
          />
        </>
      );
    }
  }

  if (billingInfo.type === 'insurance-commercial') {
    const isEligible = billingInfo.eligibilityCheckResult === EligibilityCheckResult.IN_NETWORK;
    const isOutOfNetwork = billingInfo.insuranceData.networkStatus === 'Out-of-network';

    if (isOutOfNetwork) {
      track(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.OUT_OF_NETWORK, { isResumedLead });
    } else {
      track(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.COMMERCIAL, { isResumedLead });
    }

    return (
      <>
        <DirectSignupInsuranceEligibilitySection
          showUpdateInfo={showUpdateInfo}
          setShowUpdateInfo={setShowUpdateInfo}
        />
        {(isEligible || isOutOfNetwork) && <CommercialInsuranceSections />}
      </>
    );
  }

  return null;
};

export default InsuranceSections;
